export default __webpack_public_path__ + "static/media/sample1.84ca8ede.jpeg";